<div class="code-container">
  <input
    *ngFor="let _ of code; let i = index; trackBy: trackByIndex"
    #codeInput
    type="text"
    inputmode="numeric"
    maxlength="1"
    autocomplete="one-time-code"
    class="code-input"
    (input)="onInput($event, i)"
    (keydown)="onKeyDown($event, i)"
  />
</div>

